import React, { useContext, useEffect, useState } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import { Container, Row, Card, Button, Dropdown, Image, Alert, Modal, Col } from 'react-bootstrap';

import { Link, redirect, useNavigate } from "react-router-dom";

import { AuthContext } from "../../../Authentication/AuthProvider";
import { auth, firestore } from "../../../Database/firebase";

import "./../../../component_home/content/content.css"

import { BsSearch } from "react-icons/bs";
import { FaBook } from "react-icons/fa";

function MyProduct() {

    const [currentUser, setCurrentUser] = useState(null);
    const authContext = useContext(AuthContext);


    var user = auth.currentUser;

    var uid = "";

    if (user != null) {
        
        uid = user.uid;  
        console.log(uid);
        
    }

    //CHECHK ROLE
    const [role, setRole] = useState("");
    const [displayName, setDisplayName] = useState("");
    useEffect(() => {
        const userRef = firestore.collection("user");
        const query = userRef
        
            .where("uid", "==", uid);
                query
                .get()
                .then((querySnapshot) => {
                    let tempDataArray =[];
                    querySnapshot.forEach((doc) => {
                        if (doc.exists) {
                            console.log(doc.data());
                            tempDataArray = [...tempDataArray,
                            {
                                uid: doc.id,
                                role: doc.data().role,
 
                            },
                            
                        ];
   
    
                        setRole(doc.data().role);
                        setDisplayName(doc.data().displayName);
                        
                        
                        };
    
                    });
    
                
            },
    
                (err) => {
                    console.log(err);
                }
                
            );
    
        }, [uid]); 


    //QUERY ProductData    
      const [bookLists, setBookLists] = useState([]);
      const [currentCursor, setCurrentCursor] = useState("");
  
      useEffect(() => {
          const firsPageRef = firestore
              .collection("product")
              .where("merchantID", "==", uid)
              .orderBy("productDate", "desc")
              .limit(16);
          firsPageRef.onSnapshot((snapshot) => {
              let tempLists = [];
              snapshot.docs.forEach((doc) => {
                  if (doc.exists) {
  
                      const currentBook = {
  
                        id: doc.id,
                        productID: doc.data().productID,
                        merchantName: doc.data().merchantName,
                        productName: doc.data().productName,
                        productImage: doc.data().productImage,
                        productFullPrice: doc.data().productFullPrice,
                        productPrice: doc.data().productPrice, 
                        productTypeCategory: doc.data().productTypeCategory,
  
                        productDiscount: doc.data().productDiscount,
                        productRatingSum: doc.data().productRatingSum,
                        productRatingCount: doc.data().productRatingCount,

                        publicStatus: doc.data().publicStatus,

                        saleCount: doc.data().saleCount,

                        productDate: doc.data().productDate,
                       
  
                      };
                      tempLists = [...tempLists, currentBook];
                      
                  }
              });
  
  
              setBookLists((prv) => tempLists);
              const currentLenght = snapshot.docs.length;
              const currentCursorFromFirstPage = snapshot.docs[currentLenght - 1];
              setCurrentCursor(currentCursorFromFirstPage);
          })
      }, [uid]);
  
      const onMoreBook = () => {
          const nextPageRef = firestore
            .collection("product")
            .where("merchantID", "==", uid)
            .orderBy("productDate", "desc")
            .limit(16);
          nextPageRef.onSnapshot((snapshot) => {
              const currentLenght = snapshot.docs.length;
              if (!currentCursor) {

                  return;

              }
              const query = nextPageRef.startAfter(currentCursor);
              query.onSnapshot((snapshot) => {
                  let tempNewArray = [];
                  snapshot.forEach((doc) => {
                      if (doc.exists) {
                          tempNewArray = [
                              ...tempNewArray,
                              {
                                id: doc.id,
                                productID: doc.data().productID,
                                merchantName: doc.data().merchantName,
                                productName: doc.data().productName,
                                productImage: doc.data().productImage,
                                productFullPrice: doc.data().productFullPrice,
                                productPrice: doc.data().productPrice, 
                                productTypeCategory: doc.data().productTypeCategory,
        
                                productDiscount: doc.data().productDiscount,
                                productRatingSum: doc.data().productRatingSum,
                                productRatingCount: doc.data().productRatingCount,

                                publicStatus: doc.data().publicStatus,

                                saleCount: doc.data().saleCount,
                                productDate: doc.data().productDate,
                                  
                              },
                          ];
  
                          
                      }
                  });
  
  
                  setBookLists([...bookLists, ...tempNewArray]);
                  const currentCursorForNextPage = snapshot.docs[currentLenght -1];
                  setCurrentCursor(currentCursorForNextPage);
              });
          });
      };

      /* const [showAddCouponCode, setShowAddCouponCode] = useState(false);
      const handleCloseAddCouponCode = () => setShowAddCouponCode(false);

      const [productID, setProductID] = useState("");
      const [productName, setProductName] = useState("");
      const [couponcodeMerchantios, setCouponcodeMerchantios] = useState("");
      const [couponcodeUserios, setCouponcodeUserios] = useState(""); */

      // ฟังก์ชันสำหรับสร้าง array ที่มีสมาชิกเป็นค่าตัวเลขสุ่ม
       /*  function generateRandomArray(size) {
            let randomArray = [];
            for (let i = 0; i < size; i++) {
                randomArray.push("cc" + Math.random(999).toString()); // ตัวเลขสุ่มระหว่าง 0 ถึง 99
            }
            return randomArray;
        } */

      // สร้าง Array ที่มีสมาชิก 100 ตัว
       /*  let randomArray = generateRandomArray(10);
        console.log(randomArray); */


      // ฟังก์ชันสำหรับกำหนดข้อมูลที่จะเพิ่ม Array ใน Product
      /* const submitHandler = (e) => {
        e.preventDefault();
      
        const obj = {
            
            couponcodeMerchantios :  couponcodeMerchantios.concat(randomArray),
            couponcodeUserios : couponcodeUserios.concat(randomArray),

        };
      
    
        editHandler(obj);
    }; */


    // ฟังก์ชั่นสำหรับเพิ่มข้อมูลใน Firestore ใน field ชื่อ couponcodeMerchantios, couponcodeUserios
    /* const editHandler = (obj) => {
        
        const ref = firestore.collection("product");
        ref
            .doc(productID)
            .update(obj)
            .then(() => {

                <Alert>เพิ่ม Coupon Code สำเร็จ</Alert>;
                
            })
            .catch((err) => console.log(err));
    }; */

   
    return (
  
      <Container>


        {(role == 'admin' || role == 'merchant') ? (

        <>

        <br/>
        <h3 style={{fontWeight: 'bold'}}><strong><FaBook /> สินค้าของ <span style={{color: 'dodgerblue'}}>{displayName}</span></strong></h3>

        <br/>

       

            {!!bookLists ? 
                    (
                        <>

                            <Row>
            
                                {bookLists.map((item, index) => {
                                    return (
                                        <div key={index}>     
                                        {/* <h3 className="pb-3 border-bottom"></h3> */}
                                            <br/>
                                            <Card className="rounded-0">
                                                <Card.Header>
                                                    <strong>{item.productName}</strong>
                                                </Card.Header>
                                            <Card.Body>
            
                                            <Card.Img style={{marginLeft: 'auto', marginRight: 'auto', width: 140, height: 200}} src={item.productImage} />
                                    
                                                <Card.Text>
                                                    <strong>productID:</strong> {item.productID}<br/>
                                                    <strong>วันที่เพิ่มสินค้า:</strong> {(item.productDate).toDate().toLocaleDateString('th-TH', {year: 'numeric', month: 'short', day: 'numeric', weekday: 'short',})}<br/><br/>
                                                    <strong>ราคาเต็ม:</strong> {item.productFullPrice}<br/>
                                                    <strong>ส่วนลด:</strong> {item.productDiscount} %<br/>
                                                    <strong>ราคาขาย:</strong> {item.productPrice}<br/>
                                                    <strong>จำนวนที่ขายทั้งหมด:</strong> {item.saleCount}<br/>
                                                    
       
                                                    <br/>
                                                  
                                                </Card.Text>
                                            </Card.Body>
                                        </Card>
            
                                        </div>
                                    );
                                })}
                        
                            </Row>
                            <br/>
            
                            {currentCursor ? (
                                <Button variant="outline-dark" onClick={() => {onMoreBook()}} style={{display: 'flex', marginLeft: 'auto', marginRight: 'auto'}}> 
                                    แสดงเพิ่มเติม
                                </Button>
                                ) : (
                                <Button variant="outline-dark" style={{display: 'flex', marginLeft: 'auto', marginRight: 'auto'}}> 
                                    ไม่มีสินค้าเพิ่มเติม
                                </Button>
                            )}
            
                        </>
            
                    ) : (
            
                        <>
                            <br/>
                            <h3><strong>สินค้าของฉัน</strong></h3>
                            <h3 className="pb-3 border-bottom"></h3>
                            <br/>
                            <p>ไม่พบสินค้าของฉัน</p>
                            <br/>
                            <br/>
                            <br/>
                            <br/>
                            <br/>
                            <br/>
                            <br/>
                            <br/>
                        </>
            
                    )}

        </>
    
         ) : (

            <>
                <br/>
                <h3><strong>กำลังดำเนินการ</strong></h3>
                <h3 className="pb-3 border-bottom"></h3>
                <br/>
                <p>กำลังดำเนินการโหลดข้อมูล</p>
                <br/>
                <br/>
                <br/>
                <br/>
                <br/>
                <br/>
                <br/>
                <br/>
            
            </>
        )}

        
    
        

        <br/>
        <br/>


        {/* <Modal 
            show={showAddCouponCode} 
            onHide={handleCloseAddCouponCode} 
            animation={false} 
            size="m"
            aria-labelledby="contained-modal-title-vcenter"
            centered>

            <Modal.Header>
                <Modal.Title>เพิ่ม Coupon Code</Modal.Title>
            </Modal.Header>
                                          
            <Modal.Body>
                เพิ่ม Coupon Code หนังสือ {productName} เพื่อจำหน่ายในระบบ ios {productID}
            </Modal.Body>

            <Modal.Footer>
                <Button variant="secondary" onClick={handleCloseAddCouponCode}>
                    ยกเลิก
                </Button>
                <Button variant="primary" onClick={submitHandler}>
                    เพิ่ม Coupon Code
                </Button>
            </Modal.Footer>
        </Modal> */}

      </Container>
    );
  }
  
  export default MyProduct;